"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledControl = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _identifier = require("../../util/identifier");
var _FormField = require("../FormField/FormField.context");
var _LabeledControl = require("./LabeledControl.styles");
var _excluded = ["control", "controlId", "disabled", "label", "size"];
var defaultProps = {
  labelPosition: _constants.LABELED_CONTROL_POSITIONS.right,
  size: 'md'
};

/**
 * @related ['Checkbox', 'Label', 'Radio', 'Switch']
 * @since 6.0.0
 */
var LabeledControl = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _defaultProps$props = Object.assign({}, defaultProps, props),
    control = _defaultProps$props.control,
    controlId = _defaultProps$props.controlId,
    disabled = _defaultProps$props.disabled,
    label = _defaultProps$props.label,
    size = _defaultProps$props.size,
    rest = (0, _objectWithoutProperties2.default)(_defaultProps$props, _excluded);
  var context = Object.assign({}, (0, _react.useContext)(_FormField.FormFieldContext), {
    // Create a default id to be used with the control and labels
    controlId: (0, _react.useRef)((0, _identifier.identifier)()).current
  });
  if (typeof controlId !== 'undefined') {
    context.controlId = controlId;
  }
  if (typeof disabled !== 'undefined') {
    context.disabled = disabled;
  }
  if (typeof props.size !== 'undefined') {
    context.size = props.size;
  }
  var merged = Object.assign({}, defaultProps, context, props);

  // Note: selection control components should come first in the DOM tree so that
  // labels can trigger off :hover/:focus states.
  return /*#__PURE__*/_react.default.createElement(_LabeledControl.StyledLabeledControl, (0, _extends2.default)({
    ref: forwardedRef,
    size: merged.size
  }, rest), /*#__PURE__*/_react.default.createElement(_FormField.FormFieldContext.Provider, {
    value: context
  }, control, label));
});
exports.LabeledControl = LabeledControl;
LabeledControl.displayName = 'LabeledControl';
LabeledControl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `Label` component.
   */
  label: _propTypes.default.node.isRequired,
  /**
   * A `Checkbox` or `Radio` component.
   */
  control: _propTypes.default.node.isRequired,
  /**
   * Identifier used for form controls and labels.
   * This will set `id` for form controls and `htmlFor` for
   * `Label` components.
   */
  controlId: _propTypes.default.string,
  /**
   * Displays the control in a disabled state. Can also be inherited from a FieldSet parent.
   *
   * @since 6.7.0
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, this will span the entire width. Be careful: while appealing at mobile sizes,
   * this may result in too much space between the label and input at larger widths.
   */
  fluid: _propTypes.default.bool,
  /**
   * Where to align the label with respect to the selection control.
   */
  labelPosition: _propTypes.default.oneOf(Object.values(_constants.LABELED_CONTROL_POSITIONS)),
  /**
   * Sets the `size` of the control. This currently only works with Switches.
   *
   * @since 6.7.0
   */
  size: _propTypes.default.oneOf(['md', 'lg'])
} : {};